import { useMutation, useQueryClient } from '@tanstack/react-query';
import { KeywordService } from 'modules/cms/seo/keyword/services';
import { KEYWORDS_LIST_KEY } from 'modules/cms/seo/keyword/constants';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useDeleteKeyword = (id: string, onClose: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('keyword');
  return useMutation(() => KeywordService.delete(id), {
    onSuccess: (data) => {
      toast.success(t('successDeleted'));
      onClose?.();
      queryClient.invalidateQueries({ queryKey: [KEYWORDS_LIST_KEY] });
      queryClient.invalidateQueries({ queryKey: [id] });
    },
  });
};
